interface Props {
  /** Formatted progress line, e.g. `$0.00 of $100.00 raised`. */
  raisedLabel: string;
  /** Progress toward the goal, 0..1. */
  progress: number;
  /** Shorter bar for tight surfaces (the chat-bubble post card). */
  compact?: boolean;
}

/**
 * Crowd-tipping progress bar — a light pill with the raised/goal label centered,
 * filled left-to-right in mint green. 1:1 with legacy `PostTippingProgressBar`.
 */
export function TipProgress({ raisedLabel, progress, compact }: Props) {
  const pct = Math.round(Math.min(1, Math.max(0, progress)) * 100);
  return (
    <div
      className={`relative w-full overflow-hidden rounded-full bg-neutral-200 ${compact ? 'h-6' : 'h-8'}`}
    >
      <div
        className="bg-brand absolute inset-y-0 left-0"
        style={{ width: `${pct}%` }}
        aria-hidden
      />
      <span
        className={`relative flex h-full items-center justify-center font-medium text-black ${compact ? 'text-[11px]' : 'text-[12px]'}`}
      >
        {raisedLabel}
      </span>
    </div>
  );
}
